// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationQuestionField {
  margin-bottom: 1.5rem;
}
.EvaluationQuestionField-Text {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.EvaluationQuestionField-Options {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
}
.EvaluationQuestionField-Options .RadioButton {
  width: auto;
  flex: 1 1 0;
  border-radius: var(--bs-border-radius-pill);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1), 4px 6px 6px 0 rgba(0, 0, 0, 0.06);
}
.EvaluationQuestionField-Options .RadioButton-Checked, .EvaluationQuestionField-Options .RadioButton:hover {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;
  background-color: rgba(var(--bs-gray-subtle-rgb), 0.15);
}
.EvaluationQuestionField-Notes {
  margin-top: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/EvaluationQuestionField/styles.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,gBAAA;EACA,qBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AAEI;EACE,WAAA;EACA,WAAA;EACA,2CAAA;EACA,6EACE;AADR;AAIM;EAEE,iDAAA;EACA,uDAAA;AAHR;AAQE;EACE,mBAAA;AANJ","sourcesContent":[".EvaluationQuestionField {\n  margin-bottom: 1.5rem;\n\n  &-Text {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n  }\n\n  &-Options {\n    display: flex;\n    flex-direction: row;\n    gap: 0.75rem;\n\n    .RadioButton {\n      width: auto;\n      flex: 1 1 0;\n      border-radius: var(--bs-border-radius-pill);\n      box-shadow:\n        0 4px 4px 0 rgba(0, 0, 0, 0.1),\n        4px 6px 6px 0 rgba(0, 0, 0, 0.06);\n\n      &-Checked,\n      &:hover {\n        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;\n        background-color: rgba(var(--bs-gray-subtle-rgb), 0.15);\n      }\n    }\n  }\n\n  &-Notes {\n    margin-top: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
